import { LayoutFolha, TipoDescontoDSR } from '@acme/core'
import dayjs from 'dayjs'
import TabbedDialog from 'global/guides/Dialog/TabbedDialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useNavigate } from 'react-router-dom'
import { createEmpresaSchema, Empresa, empresas } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { tabs } from '../constants/tabs'

export default function AdicionarEmpresaPage() {
    const navigate = useNavigate()
    const cliente = useStore(state => state.customer)
    const { mutateAsync, isLoading } = empresas.mutations.useCreate({
        invalidateQuery: true,
    })

    function handleSubmit(data: Empresa) {
        return mutateAsync(data, {
            onSuccess: () => {
                toast.success('Empresa adicionada com sucesso!')
            },
            onError: ({ statusCode, message }) => {
                if (statusCode === 422) {
                    ;(message as string[]).forEach(error => toast.error(error))
                } else {
                    toast.error(message)
                }
            },
        })
    }

    return (
        <TabbedDialog.Root
            loading={isLoading}
            onClose={() => navigate('/cadastros/empresas')}
            onSubmit={handleSubmit}
            open={hasPermission(['create', 'Empresas'])}
            tabs={tabs}
            schema={createEmpresaSchema}
            defaultValues={{
                clienteId: cliente?.id,
                diasRescisao: 40,
                layoutFolha: LayoutFolha.DOMINIO,
                tipoDescontoDSR: TipoDescontoDSR.NAO_DESCONTAR,
                periodoDescontoDSR: 'DIA',
                ocultarInfoRodapeEspelho: 'N',
                competenciaAtual: dayjs().format('YYYY-MM'),
                horarioInicioAdicionalNoturno: '22:00',
                horarioFimAdicionalNoturno: '05:00',
                diaInicioPonto: '01',
                temAdicionalNoturno: 'N',
                reducaoHrsATrabalhar: 'N',
                reducaoSomenteAdicionalNoturno: 'N',
                dsrDescontaFeriado: 'N',
                dsrExibeHoras: 'N',
                exportarHorasFaltaJustificada: 'N',
                exibirSaldoDiario: 'N',
                faltaJustificadaDescontaDSR: 'N',
            }}
        >
            <TabbedDialog.Title>Adicionar empresa</TabbedDialog.Title>
            <TabbedDialog.Content dividers />
            <TabbedDialog.Actions>
                <TabbedDialog.Actions.SecondaryButton />
                <TabbedDialog.Actions.PrimaryButton closeOnSubmit />
            </TabbedDialog.Actions>
        </TabbedDialog.Root>
    )
}
